import React from "react";
import { useFormContext } from "react-hook-form";
import { Validation } from "../../types/form";
import { FieldErrorMessage } from "../ui/Text";

interface CheckBoxOption {
  value: string;
  link?: {
    text: string;
    value: string;
  };
}

interface CheckBoxInputProps {
  label: string;
  field: string;
  hideLabel?: boolean;
  disabled?: boolean;
  validation: Validation;
  options: CheckBoxOption[];
}

const CheckBoxInput: React.FC<CheckBoxInputProps> = ({ field, disabled = false, validation, options }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const getRegisterOptions = () => {
    const registerOptions: any = {};

    if (validation?.required) {
      registerOptions.required = validation?.requiredMessage || "This field is required.";
    }
    return registerOptions;
  };

  return (
    <>
      {options.map((option, index) => {
        const errorMessage: any = errors[field];
        return (
          <React.Fragment key={`option-${index}`}>
            <div key={index} className="flex items-center py-1">
              <div className="checkbox-wrapper-23">
                <input
                  id={`${field}_${index}`}
                  type="checkbox"
                  className={errors[field] ? "error" : ""}
                  {...register(`${field}.${index}`, getRegisterOptions())}
                  disabled={disabled}
                  hidden
                />
                <label htmlFor={`${field}_${index}`}>
                  <svg viewBox="0,0,50,50">
                    <path d="M5 30 L 20 45 L 45 5"></path>
                  </svg>
                </label>
              </div>
              <div className="ml-1.5 text-sm">
                <span className="text-gray-500">
                  {option.value}
                  {option.link && (
                    <a href={option.link.value} className="text-text-link hover:underline px-1" target="_blank" rel="noopener noreferrer">
                      {option.link.text}
                    </a>
                  )}
                </span>
              </div>
            </div>
            {errorMessage && <FieldErrorMessage text={errorMessage[index]?.message} />}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CheckBoxInput;
